/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import { View, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import { PortalHost } from '@gorhom/portal';

import Colors from '@global/colors';
import {
  isWeb,
  isMobileWeb,
  isIphoneX,
  isIos,
  isAndroid,
} from '@global/screens';

import Modal from '@components/modal/Modal';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { NoTranslate } from '@components/shared/TranslationContext';

const dimension = Dimensions.get('window');

const ModalFull = (props) => {
  const {
    testID = 'modal', // unique identifier for automation testing
    title, // title modal
    children, // content
    maxWidth, // modal max width
    width, // modal width
    onClose, // on close callback
    closeOutside = true, // allow close by clicking outside of modal
    show, // show/hide modal
    rightAction,
    withMobileMenu, // condition if need some button menus on top right side modal
    mobileMenu, // list menu for mobile
    noPortalSticky = false,
    isTransparentHeader = false,
    noTranslate = false,
  } = props;

  const insets = useSafeAreaInsets();
  const screenHeight = isWeb
    ? 'auto'
    : dimension.height - insets.top - insets.bottom - 55;
  const maxHeight = isWeb ? screenHeight - 200 : screenHeight;
  const [showMenu, setShowMenu] = useState(false);

  const onClicked = (item) => {
    item.callback();
    setShowMenu(false);
  };

  if (!show) {
    return null;
  }

  // Modal renders its children via a Portal that re-parents them onto a
  // detached PortalHost elsewhere in the tree (see @gorhom/portal's
  // PortalHost, which does `state.map(item => item.node)`), so a Context
  // provider wrapping <Modal> itself never reaches the portaled content.
  // It has to wrap the JSX passed *into* Modal instead, so it travels
  // along as part of what actually gets portaled.
  const innerContent = (
    <>
      {!isWeb && (
        <SafeAreaView
          style={{
            flex: 0,
            backgroundColor: Colors.blue1,
            ...(isIphoneX && !isMobileWeb
              ? {
                  paddingTop: 30,
                  paddingBottom: 20,
                }
              : isIos && !isMobileWeb && !isAndroid
              ? {
                  paddingTop: 10,
                  paddingBottom: 20,
                }
              : {}),
          }}
        />
      )}
      <SafeAreaView style={{ flex: 1, backgroundColor: 'transparent' }}>
        <View
          testID={`${testID}-header`}
          style={[
            styles.modalHeader,
            isWeb
              ? {
                  flexDirection: 'row-reverse',
                  justifyContent: 'space-between',
                  paddingTop: 25,
                  paddingBottom: 15,
                  paddingLeft: 15,
                  backgroundColor: Colors.white,
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }
              : {},
            !isTransparentHeader && !isWeb
              ? {
                  backgroundColor: Colors.blue1,
                }
              : {},
          ]}>
          <TouchableOpacity
            testID={`${testID}-close`}
            style={{ paddingHorizontal: 15, marginRight: isWeb ? 0 : 3 }}
            onPress={() => onClose()}>
            {props.back ? (
              <Image
                width={20}
                height={20}
                style={{ width: 20, height: 20 }}
                svg={true}
                source={
                  !isTransparentHeader
                    ? require('@assets/img/icons/arrow-left-white.svg')
                    : require('@assets/img/icons/arrow-left-black.svg')
                }
              />
            ) : (
              <Image
                width={16}
                height={16}
                style={{ width: 16, height: 16 }}
                svg={true}
                source={
                  isTransparentHeader
                    ? require('@assets/img/icons/arrow-left-black.svg')
                    : isWeb
                    ? require('@assets/img/icons/close-grey.svg')
                    : require('@assets/img/icons/close-white.svg')
                }
              />
            )}
          </TouchableOpacity>
          <SociollaText
            testID={`${testID}-title`}
            type="medium"
            style={{
              fontSize: 17,
              color: isTransparentHeader
                ? '#171D29'
                : isWeb
                ? Colors.black
                : Colors.white,
              letterSpacing: 0.5,
              width: isWeb ? '100%' : 270,
            }}
            ellipsizeMode="tail"
            numberOfLines={1}>
            {title}
          </SociollaText>
          {/* Right Action */}
          {rightAction ? (
            <View style={{ position: 'absolute', right: 0 }}>
              <TouchableOpacity
                onPress={() => rightAction.onCallback()}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingHorizontal: 15,
                }}>
                <SociollaText type="medium" style={{ color: Colors.white }}>
                  {rightAction.label}
                </SociollaText>
              </TouchableOpacity>
            </View>
          ) : (
            false
          )}
          {/* Right Action */}
          {/* Mobile Menu Container */}
          {withMobileMenu && mobileMenu && mobileMenu.length ? (
            <>
              {!isWeb ? (
                <View style={{ position: 'absolute', right: 0 }}>
                  <TouchableOpacity
                    onPress={() => setShowMenu(true)}
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      paddingHorizontal: 15,
                    }}>
                    <Image
                      width={20}
                      height={isMobileWeb ? 4 : 20}
                      style={{ width: 20, height: isMobileWeb ? 4 : 20 }}
                      svg={true}
                      source={require('@assets/img/icons/more-white.svg')}
                    />
                  </TouchableOpacity>
                  <Modal
                    transparent={true}
                    visible={showMenu}
                    animationType="none"
                    onClose={() => setShowMenu(false)}>
                    <View style={styles.menu}>
                      {(mobileMenu || []).map((item, idx) => (
                        <TouchableOpacity
                          activeOpacity={0.6}
                          style={styles.menuItem}
                          onPress={() => onClicked(item)}
                          key={idx}>
                          <SociollaText
                            style={{ fontSize: 14, letterSpacing: 0.5 }}>
                            {item.name}
                          </SociollaText>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </Modal>
                </View>
              ) : (
                false
              )}
            </>
          ) : (
            false
          )}
        </View>
        <View
          style={{
            width: '100%',
            marginBottom: isWeb ? 0 : 56,
            minHeight: screenHeight,
            maxHeight: maxHeight,
          }}>
          {children}
        </View>
      </SafeAreaView>
      {!noPortalSticky ? <PortalHost name="modal-sticky-button" /> : false}
    </>
  );

  return (
    <Modal
      testID={`${testID}-modal`}
      visible={show}
      fullPage={true}
      maxWidth={maxWidth ? maxWidth : '100%'}
      width={width ? width : 600}
      animationType={isWeb ? 'fade' : 'slide'}
      onClose={() => onClose()}
      closeOutside={closeOutside}
      onRequestClose={() => onClose()}>
      {noTranslate ? <NoTranslate>{innerContent}</NoTranslate> : innerContent}
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalHeader: {
    position: 'relative',
    width: '100%',
    height: 55,
    flexDirection: 'row',
    alignItems: 'center',
  },
  menu: {
    position: isMobileWeb ? 'fixed' : 'absolute',
    top: 55,
    right: 0,
    backgroundColor: Colors.white,
    width: 230,
  },
  menuItem: {
    color: Colors.blue1,
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
});

export default React.memo(ModalFull, (prev, next) => prev == next);
